import React from "react";
import Modal from "material-ui/Modal";
import Paper from "material-ui/Paper";
import Button from "material-ui/Button";
import Typography from "material-ui/Typography";
import Select from "material-ui/Select";
import Input, { InputLabel } from "material-ui/Input";
import { MenuItem } from "material-ui/Menu";
import Checkbox from "material-ui/Checkbox";
import TextField from "material-ui/TextField";
import Tabs, { Tab } from "material-ui/Tabs";
import Icon from "material-ui/Icon";
import { RadioGroup, Radio } from "material-ui";
import { isSignalTEK10GType, isVDVType, isSignalTEKQTType, isNaviTEKType } from '../../../common/utils'

import {
  FormControl,
  FormHelperText,
  FormControlLabel,
  FormLabel
} from "material-ui/Form";
import { withStyles } from "material-ui/styles";
import styles from "./styles";

import { ModalHeader, ModalContents, ModalFooter } from "../../common/modal";

import { validateFormData } from "../../../common/formtool";

class ReportGen extends React.Component {
  constructor(props) {
    super(props);
    const { job } = props;
    let isSignalTEK10GJob = job.deviceid && isSignalTEK10GType(job.deviceid);
    this.state = {
      errors: {},
      showNotes:
        isSignalTEK10GJob ? true : false,
      tabs: [
        props.translate
          ? props.translate("generate_report_tab_reportdetails")
          : "Report Details",
        props.translate
          ? props.translate("generate_report_tab_customerdetails")
          : "Customer Details",
        props.translate
          ? props.translate("generate_report_tab_reportoptions")
          : "Report Options"
      ],
      customer: null,
      report: {
        name: props.job && props.job.name ? props.job.name : "",
        type: isVDVType(job.deviceid) ? "mobile" : "standard",
        jobid: props.job.id ? props.job.id : "",
        customerid: "",
        language:
          isSignalTEK10GJob
            ? props.language === "en-GB"
              ? "en-US"
              : props.language
            : props.language,
        coverpageincluded: false,
        summarytableincluded: false,
        lengthincluded: false,
        includepage2: false,
        jobnotes: "",
        multiplePdf: false
      },
      languages:
        isSignalTEK10GJob
          ? props.languages.filter(item => {
            return item.code != "en-GB";
          })
          : props.languages,
      tabPosition: 0,
      // marginincluded: ["standard", "singleline"].includes(report.type)
      //   ? true
      //   : false,
      // margintype: ["standard", "singleline"].includes(report.type) ? "NEXT" : null
      marginincluded: !isSignalTEK10GJob,
      margintype: isSignalTEK10GJob ? null : "NEXT",
      customerState: "",
      customerCountry: ""
    };
  }

  onChange = e => {
    let report = { ...this.state.report };
    const { job } = this.props;
    let { marginincluded, margintype } = this.state;
    let isSignalTEK10GJob = job.deviceid && isSignalTEK10GType(job.deviceid);
    report[e.target.name] = e.target.value;
    if (
      report.type == "brief" && !isSignalTEK10GJob
    ) {
      marginincluded = false;
      margintype = null;
    } else if (
      ["standard", "singleline"].includes(report.type) &&
      !isSignalTEK10GJob
    ) {
      marginincluded = marginincluded ? marginincluded : true;
      margintype = margintype ? margintype : "NEXT";
      report["multiplePdf"] = false;
    }
    let errors = { ...this.state.errors };
    errors = {
      ...errors,
      [e.target.name]: false
    };
    this.setState({ report, errors, marginincluded, margintype });
  };

  onCheckboxChange = e => {
    let { showNotes, marginincluded, margintype } = this.state;
    let report = { ...this.state.report };
    //let marginincluded = this.state.marginincluded;
    if (e.target.name === "coverpageincluded") {
      showNotes = e.target.checked;
      report["jobnotes"] = "";
    }

    report[e.target.name] = e.target.checked;

    if (e.target.name === "coverpageincluded" && e.target.checked === false) {
      report["summarytableincluded"] = false;
      report["lengthincluded"] = false;
    }
    // if (
    //   e.target.name === "summarytableincluded" &&
    //   e.target.checked === false
    // ) {
    //   report["lengthincluded"] = false;
    // }
    if (e.target.name === "marginincluded") {
      marginincluded = e.target.checked;
      margintype = e.target.checked == true ? "NEXT" : null;
    }
    if (e.target.name === "multiplePdf") {
      report["multiplePdf"] = e.target.checked;
    }
    this.setState({ report, showNotes: showNotes, marginincluded, margintype });
  };

  onRadioChange = e => {
    let { marginincluded, margintype } = this.state;
    if (marginincluded && e.target.name === "margintype") {
      margintype = e.target.value;
    }
    this.setState({ margintype });
  };

  onChangeCustomer = e => {
    this.props.getCustomer(e.target.value);
    let report = { ...this.state.report };
    let errors = { ...this.state.errors };
    errors = {
      ...errors,
      [e.target.name]: false
    };

    report.customerid = e.target.value;
    this.setState({ report, errors });
  };

  handleTabChange = (event, value) => {
    let validate = this.validate();
    let { tabPosition } = this.state;
    let prevTabClicked = tabPosition > value;
    let allowTabChange = prevTabClicked ? true : validate;
    if (allowTabChange) {
      this.setState({ tabPosition: value });
    }
  };

  handleContinue = () => {
    let validate = this.validate();
    if (validate) {
      let posistion = this.state.tabPosition;
      this.setState({ tabPosition: ++posistion });
    }
  };

  handleClose = () => {
    this.props.cancel();
  };

  handleSubmit = () => {
    let isValidated = false;
    const { tabPosition, marginincluded, margintype } = this.state;
    for (let currentTab = 0; currentTab <= tabPosition; currentTab++) {
      isValidated = this.validate(currentTab);
      if (!isValidated) {
        return;
      }
    }
    if (isValidated) {
      let data = { ...this.state.report };
      //this.props.selectAll ? (data.selectAll = true) : (data.selectAll = false)
      if (this.props.selectedTests && this.props.selectedTests.length) {
        data.testids = this.props.selectedTests.map(test => test.id);
      } else {
        this.props.selectAll
          ? (data.selectAll = true)
          : (data.selectAll = false);
        data.testids = [];
      }
      data.margintype = marginincluded && margintype ? margintype : null;
      data.marginincluded = marginincluded;
      data.jobnotes = data.jobnotes.replaceAll("\n", "\\n");
      this.props.submit(data);
    }
  };

  validate = currentTab => {
    const { report, tabPosition } = this.state;
    const { translate } = this.props;
    let validationData = {};
    let errors = {};
    switch (currentTab || currentTab === 0 ? currentTab : tabPosition) {
      case 0:
        validationData = {
          name: {
            required: translate("formfield_error_general_required"),
            pattern: {
              value: /^(?!.*[\/|\\|#|\%|\?|&|=|\|]).*$/g,
              message: translate(
                "formfield_error_name_special_character_restricted"
              )
            }
          },
          type: {
            required: translate("formfield_error_general_required")
          }
        };

        break;
      case 1:
        validationData = {
          customerid: {
            required: translate("formfield_error_general_required")
          }
        };
        break;
      case 2:
        validationData = {
          language: {
            required: translate("formfield_error_general_required")
          },
          jobnotes: {
            maxCharacter: {
              length: 1500,
              message: translate("formfield_error_jobnotes_length")
            }
          }
        };
        break;
      default:
        return true;
    }
    errors = validateFormData(report, validationData);

    const missingFieldName = Object.keys(errors)[0];
    if (missingFieldName) {
      const textField = document.getElementsByName(missingFieldName)[0];
      textField && textField.focus();
    }

    if (Object.keys(errors).length) {
      if (!currentTab && currentTab !== 0) {
        this.setState({ errors });
      } else {
        this.setState({ errors, tabPosition: currentTab });
      }
      return false;
    } else {
      return true;
    }
  };

  render() {
    const {
      job,
      translate,
      selectedtotal,
      classes,
      customers,
      selectedCustomerId
    } = this.props;

    const {
      tabs,
      tabPosition,
      errors,
      report,
      customer,
      languages,
      marginincluded,
      margintype,
      customerState,
      customerCountry
    } = this.state;

    let isSignalTEK10GJob = job.deviceid && isSignalTEK10GType(job.deviceid);
    let isBlackbirdJob = job.deviceid && (isSignalTEKQTType(job.deviceid) || isNaviTEKType(job.deviceid));
    let isVDVJob = job.deviceid && isVDVType(job.deviceid);
    let signaltekReportTypes = ["singleline", "standard"];
    if (isBlackbirdJob) {
      signaltekReportTypes = ["singleline", "standard", "brief"];
    }


    const $reportDetails = (
      <div>
        <TextField
          error={errors.name ? true : false}
          required
          name="name"
          label={translate("generate_report_report_name")}
          margin="normal"
          fullWidth
          value={report.name}
          onChange={this.onChange}
          helperText={
            errors.name
              ? errors.name
              : translate("generate_report_report_name_help")
          }
        />
        <FormControl
          className={classes.textField}
          margin="normal"
          required
          error={errors.type ? true : false}
        >
          <InputLabel htmlFor="type">
            {translate("generate_report_report_type")}
          </InputLabel>
          {isSignalTEK10GJob ? (
            <Select
              value={report.type}
              onChange={this.onChange}
              input={<Input name="type" id="reportType" value={report.type} />}
              fullWidth
            >
              {signaltekReportTypes.map((c, index) => (
                <MenuItem key={`reportType-${index}`} value={c}>
                  {translate(`generate_report_type_${c}`)}
                </MenuItem>
              ))}
            </Select>
          ) : isVDVType(job.deviceid)
            ? (
              <Select
                value={report.type}
                onChange={this.onChange}
                input={<Input name="type" id="reportType" value={report.type} />}
                fullWidth
              >
                {["mobile"].map((c, index) => (
                  <MenuItem key={`reportType-${index}`} value={c}>
                    {translate(`generate_report_type_${c}`)}
                  </MenuItem>
                ))}
              </Select>
            ) :
            (
              <Select
                value={report.type}
                onChange={this.onChange}
                input={<Input name="type" id="reportType" value={report.type} />}
                fullWidth
              >
                {["singleline", "brief", "standard"].map((c, index) => (
                  <MenuItem key={`reportType-${index}`} value={c}>
                    {translate(`generate_report_type_${c}`)}
                  </MenuItem>
                ))}
              </Select>
            )}
          <FormHelperText>
            {errors.type
              ? errors.type
              : translate("generate_report_report_type_help")}
          </FormHelperText>
        </FormControl>
        <TextField
          name="jobname"
          label={translate("generate_report_report_jobname")}
          margin="normal"
          fullWidth
          disabled
          value={job.name}
        />
        <TextField
          name="selectedtotal"
          label={translate("generate_report_report_tests")}
          margin="normal"
          fullWidth
          disabled
          value={`${selectedtotal} ${translate(
            "generate_report_report_selected"
          )}`}
        />
      </div>
    );
    const $customerDetails = (
      <div>
        <FormControl
          required
          className={classes.textField}
          margin="normal"
          error={errors.customerid ? true : false}
        >
          <InputLabel htmlFor="customer" required>
            {translate("generate_report_select_customer")}
          </InputLabel>
          {selectedCustomerId ? (
            <Select
              value={report.customerid}
              onChange={this.onChangeCustomer}
              input={
                <Input
                  name="customerid"
                  id="customerid"
                  value={report.customerid}
                  defaultValue={report.customerid}
                />
              }
              fullWidth
            >
              {customers
                ? customers.data
                  .filter(customer => customer.id == selectedCustomerId)
                  .map((customer, index) => {
                    return (
                      <MenuItem key={index} value={customer.id}>
                        {customer.name}
                      </MenuItem>
                    );
                  })
                : null}
            </Select>
          ) : (
              <Select
                value={report.customerid}
                onChange={this.onChangeCustomer}
                input={
                  <Input
                    name="customerid"
                    id="customerid"
                    value={report.customerid}
                    defaultValue={report.customerid}
                  />
                }
                fullWidth
              >
                {customers
                  ? customers.data.map((customer, index) => {
                    return (
                      <MenuItem key={index} value={customer.id}>
                        {customer.name}
                      </MenuItem>
                    );
                  })
                  : null}
              </Select>
            )}
          <FormHelperText>
            {translate("generate_report_select_customer_help")}
          </FormHelperText>
        </FormControl>
        {customer && (
          <React.Fragment>
            <TextField
              name="address"
              label={translate("customer_street")}
              margin="normal"
              fullWidth
              disabled
              value={customer.address}
            />
            <TextField
              name="city"
              label={translate("customer_city")}
              margin="normal"
              fullWidth
              disabled
              value={customer.city}
            />
            <TextField
              name="country"
              label={translate("customer_country")}
              margin="normal"
              fullWidth
              disabled
              value={customerCountry}
            />
            <TextField
              name="state"
              label={translate("customer_state_county")}
              margin="normal"
              fullWidth
              disabled
              value={customerState}
            />
            <TextField
              name="postcode"
              label={translate("customer_zipcode")}
              margin="normal"
              fullWidth
              disabled
              value={customer.zipcode}
            />
            <TextField
              name="email"
              label={translate("customer_email")}
              margin="normal"
              fullWidth
              disabled
              value={customer.contactemail}
            />
            <TextField
              name="contact"
              label={translate("customer_contact")}
              margin="normal"
              fullWidth
              disabled
              value={customer.telephoneno}
            />
          </React.Fragment>
        )}
      </div>
    );

    const $reportOptions = (
      <div>
        <FormControl
          required
          className={classes.textField}
          margin="normal"
          error={errors.language ? true : false}
        >
          <InputLabel htmlFor="language">
            {translate("general_language")}
          </InputLabel>
          <Select
            value={report.language}
            onChange={this.onChange}
            input={
              <Input
                name="language"
                id="reportLanguage"
                value={report.language}
              />
            }
            fullWidth
          >
            {languages &&
              languages.map((lang, index) => (
                <MenuItem key={`reportLanguage-${index}`} value={lang.code}>
                  {lang.code}
                </MenuItem>
              ))}
          </Select>
          <FormHelperText>
            {errors.language
              ? errors.language
              : translate("general_language_help")}
          </FormHelperText>
        </FormControl>

        {/* MARGIN */}

        {!isSignalTEK10GJob &&
          report &&
          report.type &&
          ["standard", "singleline"].includes(report.type) && (
            <FormControl margin="none" fullWidth>
              <FormControlLabel
                margin="normal"
                control={
                  <Checkbox
                    name="marginincluded"
                    checked={marginincluded}
                    onChange={this.onCheckboxChange}
                    value="marginincluded"
                  />
                }
                label={translate("generate_report_include_margin")}
              />
            </FormControl>
          )}
        {!isSignalTEK10GJob &&
          report &&
          report.type &&
          ["standard", "singleline"].includes(report.type) &&
          marginincluded && (
            <RadioGroup
              aria-label=""
              name="margintype"
              value={margintype}
              onChange={this.onRadioChange}
              //className={classes.radioGroup}
              className={classes.padded}
              row={true}
            >
              <FormControlLabel
                value={"NEXT"}
                control={<Radio />}
                label={translate("report_next")}
                disabled={!marginincluded}
              />
              <FormControlLabel
                value={"ATTEN"}
                control={<Radio />}
                label={translate("report_il")}
                disabled={!marginincluded}
              />
              <FormControlLabel
                value={"PSNEXT"}
                control={<Radio />}
                label={translate("report_psnext")}
                disabled={!marginincluded}
              />
              <FormControlLabel
                value={"ACRN"}
                control={<Radio />}
                label={translate("report_acrn")}
                disabled={!marginincluded}
              />
              <FormControlLabel
                value={"RTNLOSS"}
                control={<Radio />}
                label={translate("report_rtnloss")}
                disabled={!marginincluded}
              />
            </RadioGroup>
          )}
        {!isSignalTEK10GJob && (
          <FormControl margin="none" fullWidth>
            <FormControlLabel
              margin="normal"
              control={
                <Checkbox
                  name="coverpageincluded"
                  checked={report.coverpageincluded}
                  onChange={this.onCheckboxChange}
                  value="coverpageincluded"
                />
              }
              label={translate("generate_report_include_coverpage")}
            />
          </FormControl>
        )}
        {!isSignalTEK10GJob && (
          <FormControl margin="none" className={classes.padded} fullWidth>
            <FormControlLabel
              margin="normal"
              disabled={!report.coverpageincluded}
              control={
                <Checkbox
                  name="summarytableincluded"
                  checked={report.summarytableincluded}
                  onChange={this.onCheckboxChange}
                  value="summarytableincluded"
                />
              }
              label={translate("generate_report_include_summary_table")}
            />
          </FormControl>
        )}
        {!isSignalTEK10GJob && (
          <FormControl margin="none" fullWidth className={classes.padded}>
            <FormControlLabel
              margin="normal"
              disabled={!report.coverpageincluded}
              control={
                <Checkbox
                  name="lengthincluded"
                  checked={report.lengthincluded}
                  onChange={this.onCheckboxChange}
                  value="lengthincluded"
                />
              }
              label={translate("generate_report_include_length")}
            />
          </FormControl>
        )}
        {/* {!isSignalTEK10GJob && (
          <FormControl margin="none" fullWidth>
            <FormControlLabel
              margin="normal"
              control={
                <Checkbox
                  name="coverpageincluded"
                  checked={report.coverpageincluded}
                  onChange={this.onCheckboxChange}
                  value="coverpageincluded"
                />
              }
              label={translate("generate_report_include_coverpage")}
            />
          </FormControl>
        )}
        {!isSignalTEK10GJob && (
          <FormControl margin="none" className={classes.padded} fullWidth>
            <FormControlLabel
              margin="normal"
              disabled={!report.coverpageincluded}
              control={
                <Checkbox
                  name="summarytableincluded"
                  checked={report.summarytableincluded}
                  onChange={this.onCheckboxChange}
                  value="summarytableincluded"
                />
              }
              label={translate("generate_report_include_summary_table")}
            />
          </FormControl>
        )}
        {!isSignalTEK10GJob && (
          <FormControl margin="none" fullWidth className={classes.padded}>
            <FormControlLabel
              margin="normal"
              disabled={!report.summarytableincluded}
              control={
                <Checkbox
                  name="lengthincluded"
                  checked={report.lengthincluded}
                  onChange={this.onCheckboxChange}
                  value="lengthincluded"
                />
              }
              label={translate("generate_report_include_length")}
            />
          </FormControl>
        )} */}

        {!(isSignalTEK10GJob || isVDVJob) &&
          job &&
          job.deviceid &&
          report.type &&
          report.type != "singleline" ? (
            <FormControl margin="none" fullWidth>
              <FormControlLabel
                margin="normal"
                control={
                  <Checkbox
                    name="includepage2"
                    checked={report.includepage2}
                    onChange={this.onCheckboxChange}
                    value="includepage2"
                  />
                }
                label={translate("include_tcl_eltctl")}
              />
            </FormControl>
          ) : null}
        {!isSignalTEK10GJob &&
          job &&
          report.type &&
          report.type == "brief" ? (
            <FormControl margin="none" fullWidth>
              <FormControlLabel
                margin="normal"
                control={
                  <Checkbox
                    name="multiplePdf"
                    checked={report.multiplePdf}
                    onChange={this.onCheckboxChange}
                    value="multiplePdf"
                  />
                }
                label={translate("multiple_pdf_checkbox")}
              />
            </FormControl>
          ) : null}
        {this.state.showNotes ? (
          <TextField
            error={errors.jobnotes ? true : false}
            name="jobnotes"
            label={translate("generate_report_jobnotes")}
            multiline
            rowsMax="4"
            fullWidth
            value={report.jobnotes}
            onChange={this.onChange} 
            inputProps={{ maxLength: 1500 }}
            helperText={
              errors.jobnotes
                ? errors.jobnotes +
                " " +
                translate("job_notes_maxCharacter_help")
                : translate("generate_report_jobnotes_help") +
                " " +
                translate("job_notes_maxCharacter_help")
            }
          />
        ) : null}
      </div>
    );

    return (
      <Modal open={true} onClose={this.handleClose}>
        <div className={classes.root}>
          <Paper className={classes.modal}>
            <ModalHeader>
              <Typography
                type="headline"
                color="inherit"
                className={classes.modalHeader}
              >
                {translate("generate_report_title")}
              </Typography>
              <Button className={classes.close} onClick={this.handleClose}>
                <Icon>clear</Icon>
              </Button>
            </ModalHeader>
            <ModalContents>
              <form noValidate autoComplete="off" className={classes.form}>
                <Tabs value={tabPosition} onChange={this.handleTabChange}>
                  {tabs.map((tab, index) => {
                    return <Tab key={index} label={tab} />;
                  })}
                </Tabs>
                {tabPosition === 0 && $reportDetails}
                {tabPosition === 1 && $customerDetails}
                {tabPosition === 2 && $reportOptions}
              </form>
            </ModalContents>

            <ModalFooter>
              {tabPosition < 2 && (
                <Button
                  raised
                  className={classes.submit}
                  onClick={this.handleContinue}
                >
                  {translate("general_continue")}
                </Button>
              )}
              {tabPosition === 2 && (
                <Button
                  raised
                  className={classes.submit}
                  onClick={this.handleSubmit}
                >
                  {translate("generate_report_generate")}
                </Button>
              )}
            </ModalFooter>
          </Paper>
        </div>
      </Modal>
    );
  }
  componentWillReceiveProps(nextProps) {
    if (this.state.report.customerid && nextProps.customer) {
      this.setState({
        customer: { ...nextProps.customer }
      });
    }

    if (
      this.state.report.customerid === "" &&
      nextProps.customers &&
      nextProps.job
    ) {
      let filteredCust = nextProps.customers.data.filter(
        c => c.id === nextProps.job.customerid
      );
      if (filteredCust.length) {
        let report = { ...this.state.report };
        report.customerid = filteredCust[0].id;
        this.setState({
          report
        });
        this.props.getCustomer(filteredCust[0].id);
      }
    }
    const { customer } = nextProps;

    if (
      customer &&
      customer != this.props.customer &&
      customer.country &&
      this.props.countryStates
    ) {
      let stateOfCountry = "";
      let countries = this.props.countryStates.countries.filter(
        c => c.countrycode == customer.country
      );
      let country = countries && countries.length ? countries[0] : "";
      if (country.stateexists) {
        stateOfCountry = this.props.countryStates.states.filter(
          s => s.statecode == customer.state
        )[0];
        stateOfCountry = [undefined, null].includes(stateOfCountry)
          ? ""
          : stateOfCountry.statename;
      }
      stateOfCountry = country.stateexists ? stateOfCountry : customer.state;
      this.setState({
        customerState: stateOfCountry,
        customerCountry: country ? country.countryname : ""
      });
    }
  }
}

export default withStyles(styles)(ReportGen);
